import { type Product, Country } from '@/domainLogic/index.ts';
import {
  hasLastminuteDeDeeplink,
  hasLastminuteDeLabel,
  isOpxUrlaub,
} from '@/app/components/search/components/Card/utils/getOpxPromotions.ts';
import type { Localization } from '../../common/Localization';

export const isTourOperatorDeal = (product: Product): boolean => !!product?.rate?.flags?.opx;

export const isTourOperatorGermany = (localization: Localization): boolean => localization.country === Country.DE;

export const isTourOperatorDealFrance = (product: Product, localization: Localization): boolean =>
  isTourOperatorDeal(product) && localization?.country === Country.FR;

export const isTourOperatorDealOther = (product: Product, localization: Localization): boolean =>
  isTourOperatorDeal(product) && localization?.country !== Country.FR;

export const isTourOperatorLastminuteDeDeal = (product: Product, localization: Localization) =>
  hasLastminuteDeLabel(localization, isTourOperatorDeal(product)) ||
  hasLastminuteDeDeeplink(localization, isTourOperatorDeal(product)) ||
  isOpxUrlaub(localization, isTourOperatorDeal(product));
